module.exports = __webpack_public_path__ + "static/media/ios-mail.03a19724.svg";